import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

const CalendarIcon = (props: SVGProps<any>): ReactElement => {
  return (
    <BaseIcon {...props}>
      <path
        d="M19.5 3.452h-2.438v-.937a.563.563 0 1 0-1.124 0v.937H8.062v-.937a.563.563 0 0 0-1.124 0v.937H4.5a1.312 1.312 0 0 0-1.313 1.312v15A1.312 1.312 0 0 0 4.5 21.077h15a1.312 1.312 0 0 0 1.312-1.313v-15A1.312 1.312 0 0 0 19.5 3.452Zm-15 1.125h2.437v.938a.563.563 0 0 0 1.124 0v-.938h7.876v.938a.563.563 0 1 0 1.124 0v-.938h2.438a.187.187 0 0 1 .187.187v3.187H4.312V4.764a.187.187 0 0 1 .188-.187Zm15 15.375h-15a.187.187 0 0 1-.188-.188V9.078h15.375v10.687a.187.187 0 0 1-.187.188Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};
export default CalendarIcon;
